import { motion } from "framer-motion";
import { splitTitle } from "@/lib/event";

export function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.6, delay, ease: [0.2, 0.8, 0.2, 1] }}>
      {children}
    </M>
  );
}

export function SectionHead({ eyebrow, title, children, light = false, id, center = false }) {
  return (
    <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className={`eyebrow ${light ? "eyebrow-light" : ""}`}>{eyebrow}</p>}
      <h2 id={id} className={`font-poster mt-3 text-[clamp(2.6rem,11vw,5.2rem)] leading-[0.92] ${light ? "text-[var(--cream)]" : "text-[var(--navy)]"}`}>{title}</h2>
      {children && <div className={`font-serif-i mt-3 text-xl leading-snug sm:text-2xl ${light ? "text-[var(--cream)]" : "text-[var(--navy)]"}`}>{children}</div>}
    </Reveal>
  );
}

export function PosterTitle({ text, ready = true, light = false, className = "", as = "h1", id }) {
  const { l1, l2, last } = splitTitle(text);
  const T = as;
  const line = (content, i) => (
    <span className="block overflow-hidden pb-[0.08em]" aria-hidden="true">
      <motion.span className="block" initial={{ y: "110%" }} animate={{ y: ready ? "0%" : "110%" }} transition={{ delay: 0.1 + i * 0.14, duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}>
        {content}
      </motion.span>
    </span>
  );
  return (
    <T id={id} aria-label={text} className={`font-poster leading-[0.9] ${light ? "text-[var(--cream)]" : "text-[var(--navy)]"} ${className}`} data-testid="poster-title">
      {line(l1, 0)}
      {line(
        <>
          {l2 && <span>{l2} </span>}
          <span className={`font-serif-i text-[1.12em] leading-[0.8] ${light ? "text-[var(--yellow)]" : "text-[var(--pink)]"}`}>{last}</span>
        </>,
        1
      )}
    </T>
  );
}
